import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../../constants';
import { brand } from '../../brand/brand';
import { logo } from '../../brand/assets';
import LoaderInline from '../../components/Loader/LoaderInline';
import { CLIENT_UPLOAD_KINDS, shrinkImage } from './clientUploadKinds';

// ÐÑÐ±Ð»Ð¸ÑÐ½Ð°Ñ ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð±ÐµÐ· Ð»Ð¾Ð³Ð¸Ð½Ð°: ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾ ÑÑÑÐ»ÐºÐµ/QR Ð¾Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð¿ÑÐ¸ÑÑÐ»Ð°ÐµÑ
// Ð²ÑÐ¿Ð¸ÑÐºÑ Ð¸ ÑÐ¾ÑÐ¾. Ð¢Ð¾Ð»ÑÐºÐ¾ Ð³Ð¾Ð»ÑÐ¹ axios â ÑÐ¾ÐºÐµÐ½ Ð°Ð²ÑÐ¾ÑÐ¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð´ÐµÑÑ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½.
const base = (token) => `${apiUrl}/api/public/clientUpload/${token}`;

const errorText = (e) =>
  e?.response?.data?.errorMessage || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ°Ð¹Ð». ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð¸Ð½ÑÐµÑÐ½ÐµÑ Ð¸ Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ ÐµÑÑ ÑÐ°Ð·.';

const Pick = ({ children, capture, accept, disabled, onFile, primary, small }) => (
  <label
    style={{
      ...styles.button,
      ...(primary ? styles.primary : styles.secondary),
      ...(small ? styles.small : {}),
      opacity: disabled ? 0.5 : 1,
    }}
  >
    {children}
    <input
      type="file"
      accept={accept}
      capture={capture}
      disabled={disabled}
      style={{ display: 'none' }}
      onChange={(e) => {
        onFile(e.target.files?.[0]);
        e.target.value = '';
      }}
    />
  </label>
);

const Card = ({ number, kind, done, preview, busy, progress, error, locked, onFile }) => {
  const meta = CLIENT_UPLOAD_KINDS[kind];
  const accept = meta.photo ? 'image/*' : 'application/pdf,image/*';
  return (
    <div style={{ ...styles.card, ...(done ? styles.cardDone : {}) }}>
      <div style={styles.cardHead}>
        <span style={{ ...styles.badge, ...(done ? styles.badgeDone : {}) }}>{done ? 'â' : number}</span>
        <div>
          <b>{meta.title}</b>
          <div style={styles.hint}>{meta.hint}</div>
        </div>
      </div>

      {done && preview?.url && <img src={preview.url} alt="" style={styles.preview} />}

      {busy ? (
        <div>
          <div style={styles.barBack}>
            <div style={{ ...styles.barFill, width: `${progress}%` }} />
          </div>
          <div style={styles.hint}>ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼â¦ {progress}%</div>
        </div>
      ) : done ? (
        <div style={styles.doneRow}>
          <span style={styles.doneText}>ÐÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ</span>
          <Pick small accept={accept} disabled={locked} onFile={onFile}>
            ÐÐ°Ð¼ÐµÐ½Ð¸ÑÑ
          </Pick>
        </div>
      ) : (
        <div style={styles.actions}>
          {meta.photo ? (
            <>
              <Pick primary capture="user" accept={accept} disabled={locked} onFile={onFile}>
                Ð¡ÑÐ¾ÑÐ¾Ð³ÑÐ°ÑÐ¸ÑÐ¾Ð²Ð°ÑÑÑÑ
              </Pick>
              <Pick accept={accept} disabled={locked} onFile={onFile}>
                ÐÑÐ±ÑÐ°ÑÑ Ð¸Ð· Ð³Ð°Ð»ÐµÑÐµÐ¸
              </Pick>
            </>
          ) : (
            <>
              <Pick primary capture="environment" accept="image/*" disabled={locked} onFile={onFile}>
                Ð¡ÑÐ¾ÑÐ¾Ð³ÑÐ°ÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ
              </Pick>
              {/* Ð¢Ð¾Ð»ÑÐºÐ¾ PDF: ÑÐ¾ ÑÐ¼ÐµÑÐ°Ð½Ð½ÑÐ¼ accept Ð¼Ð½Ð¾Ð³Ð¸Ðµ Android-ÑÐµÐ»ÐµÑÐ¾Ð½Ñ Ð¾ÑÐºÑÑÐ²Ð°ÑÑ Ð»Ð¸ÑÑ Ð²ÑÐ±Ð¾Ñ ÑÐ¾ÑÐ¾, Ð±ÐµÐ· Â«Ð¤Ð°Ð¹Ð»Ð¾Ð²Â». */}
              <Pick accept="application/pdf,.pdf" disabled={locked} onFile={onFile}>
                ÐÑÐ±ÑÐ°ÑÑ PDF-ÑÐ°Ð¹Ð»
              </Pick>
              <Pick small accept="image/*" disabled={locked} onFile={onFile}>
                Ð¤Ð¾ÑÐ¾ Ð¸Ð· Ð³Ð°Ð»ÐµÑÐµÐ¸
              </Pick>
            </>
          )}
        </div>
      )}
      {error && <div style={styles.error}>{error}</div>}
    </div>
  );
};

const ClientUpload = () => {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [fatal, setFatal] = useState(null);
  const [uploaded, setUploaded] = useState([]);
  const [previews, setPreviews] = useState({});
  const [busy, setBusy] = useState(null);
  const [progress, setProgress] = useState(0);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    // Ð¢Ð¾ÐºÐµÐ½ Ð² Ð°Ð´ÑÐµÑÐµ: Ð½Ðµ Ð¾ÑÐ´Ð°ÑÐ¼ ÐµÐ³Ð¾ Ð² Referer Ð¸ Ð½Ðµ Ð¿ÑÑÐºÐ°ÐµÐ¼ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð² Ð¿Ð¾Ð¸ÑÐºÐ¾Ð²Ð¸ÐºÐ¸.
    const metas = [
      ['referrer', 'no-referrer'],
      ['robots', 'noindex, nofollow'],
    ].map(([name, content]) => {
      const m = document.createElement('meta');
      m.name = name;
      m.content = content;
      document.head.appendChild(m);
      return m;
    });
    return () => metas.forEach((m) => m.remove());
  }, []);

  useEffect(() => {
    axios
      .get(base(token))
      .then((res) => {
        setInfo(res.data);
        setUploaded(res.data.uploaded || []);
      })
      .catch((e) => setFatal(e?.response?.data?.errorMessage || 'Ð¡ÑÑÐ»ÐºÐ° Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð°. ÐÐ¾Ð¿ÑÐ¾ÑÐ¸ÑÐµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð¿ÑÐ¸ÑÐ»Ð°ÑÑ Ð½Ð¾Ð²ÑÑ.'));
  }, [token]);

  const send = useCallback(
    async (kind, picked) => {
      if (!picked) return;
      setBusy(kind);
      setProgress(0);
      setErrors((prev) => ({ ...prev, [kind]: null }));
      try {
        const file = await shrinkImage(picked);
        const form = new FormData();
        form.append('file', file);
        await axios.post(`${base(token)}/${kind}`, form, {
          onUploadProgress: (ev) => ev.total && setProgress(Math.round((ev.loaded * 100) / ev.total)),
        });
        setUploaded((prev) => (prev.includes(kind) ? prev : [...prev, kind]));
        setPreviews((prev) => ({
          ...prev,
          [kind]: file.type.startsWith('image/') ? { url: URL.createObjectURL(file) } : null,
        }));
      } catch (e) {
        setErrors((prev) => ({ ...prev, [kind]: errorText(e) }));
      } finally {
        setBusy(null);
      }
    },
    [token]
  );

  const header = (
    <div style={styles.header}>
      <img src={logo} alt={brand.title} style={{ height: 28 }} />
    </div>
  );

  if (fatal) {
    return (
      <div style={styles.root}>
        {header}
        <div style={styles.page}>
          <h2 style={styles.h2}>Ð¡ÑÑÐ»ÐºÐ° Ð½Ðµ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ</h2>
          <p>{fatal}</p>
        </div>
      </div>
    );
  }
  if (!info) {
    return (
      <div style={styles.root}>
        {header}
        <div style={{ ...styles.page, textAlign: 'center' }}>
          <LoaderInline />
        </div>
      </div>
    );
  }

  const total = info.kinds.length;
  const sent = info.kinds.filter((k) => uploaded.includes(k)).length;

  return (
    <div style={styles.root}>
      {header}
      <div style={styles.page}>
        <h2 style={styles.h2}>ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð´Ð»Ñ Ð·Ð°ÑÐ²ÐºÐ¸</h2>
        <div style={styles.counter}>
          ÐÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾: {sent} Ð¸Ð· {total}
        </div>

        {info.kinds.map((kind, i) =>
          CLIENT_UPLOAD_KINDS[kind] ? (
            <Card
              key={kind}
              number={i + 1}
              kind={kind}
              done={uploaded.includes(kind)}
              preview={previews[kind]}
              busy={busy === kind}
              progress={progress}
              error={errors[kind]}
              locked={busy !== null}
              onFile={(f) => send(kind, f)}
            />
          ) : null
        )}

        {sent === total && (
          <div style={styles.finish}>
            <b>ÐÐ¾ÑÐ¾Ð²Ð¾!</b> ÐÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ñ. Ð­ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð·Ð°ÐºÑÑÑÑ.
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  root: { minHeight: '100vh', background: '#f6f6f6', fontFamily: 'system-ui, sans-serif', color: '#222' },
  header: { background: 'var(--brand-dark, #494136)', padding: '14px 20px' },
  page: { maxWidth: 480, margin: '0 auto', padding: '20px 16px 40px', display: 'grid', gap: 14 },
  h2: { margin: 0, fontSize: 22 },
  counter: { fontWeight: 600 },
  card: { background: '#fff', border: '1px solid #e2e2e2', borderRadius: 12, padding: 16, display: 'grid', gap: 12 },
  cardDone: { borderColor: '#1a8f3c' },
  cardHead: { display: 'flex', gap: 12, alignItems: 'center' },
  badge: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    background: 'var(--brand-dark, #494136)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    fontWeight: 600,
  },
  badgeDone: { background: '#1a8f3c' },
  hint: { color: '#777', fontSize: 14 },
  preview: { maxWidth: '100%', maxHeight: 220, objectFit: 'contain', borderRadius: 8, justifySelf: 'center' },
  actions: { display: 'grid', gap: 8 },
  button: { borderRadius: 10, padding: '14px 16px', textAlign: 'center', cursor: 'pointer', fontSize: 16, fontWeight: 600 },
  primary: { background: 'var(--brand-dark, #494136)', color: '#fff' },
  secondary: { background: '#fff', color: 'var(--brand-dark, #494136)', border: '1px solid var(--brand-dark, #494136)' },
  barBack: { height: 8, background: '#e8e8e8', borderRadius: 4, overflow: 'hidden', marginBottom: 6 },
  barFill: { height: '100%', background: '#1a8f3c', transition: 'width .2s' },
  small: { padding: '8px 16px', fontSize: 14 },
  doneRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 },
  doneText: { color: '#1a8f3c', fontSize: 14, fontWeight: 600 },
  error: { color: '#c0392b', fontSize: 14 },
  finish: { background: '#e6f4ea', borderRadius: 12, padding: 16 },
};

export default ClientUpload;
